module.exports = __webpack_public_path__ + "static/media/tinytattoo-newlogo.411f3e2e.jpeg";